module.exports = __webpack_public_path__ + "img/icon-service.86022a71.png";